import { IContractFormikStatus } from 'services/templates/types';
import { contractTemplateFormInitialStatus } from '../form/contractTemplateFormInitialStatus';

export const agreementTemplateInitialStatus: IContractFormikStatus = {
  ...contractTemplateFormInitialStatus,
  minDepth: 3,
  maxDepth: 3,
  hideContract: true,
};
